/**
 * 初期処理
 *
 **/
$(window).on('load', function() {

  // 希望地域の制御
  oh_kibou_chiiki();

  // 沿線・駅のブロック制御
  oh_railway_more();

  // // 連絡方法選択時の制御
  // oh_click_contact_way();

});


/**
 * 鉄道会社設定
 *
 */
(function () {
  $("#railway1, #railway2, #railway3").on('change', function(el) {

    var kbn = '';
    switch ($(this).attr('id')){
      case 'railway1':
        kbn = '1'
        break;
      case 'railway2':
        kbn = '2'
        break;
      case 'railway3':
        kbn = '3'
        break;
    }

    if ($(this).valid() && kbn != '') {
      var data = {railway:$("option:selected", this).val()};
      oh_set_rwcompany(RAILWAY_API_URL, kbn, data);
    }

  });
}());

/**
 *
 * @param {*} url
 * @param {*} kbn
 * @param {*} data
 */
var oh_set_rwcompany = function(url, kbn, data) {
  $.ajax({
    mode: "abort",
    type: "get",
    url: url,
    data: data,
    dataType: 'json',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    success: function(params, status){oh_set_rwcompany_callback(params,kbn)}
  });
};

/**
 * 沿線情報を取得し、内容を変更する関数(コールバック)
 * @param {*} params
 * @param {*} kbn
 */
var oh_set_rwcompany_callback = function(params,kbn) {
  var node_parent = $('#line' + kbn);
  node_parent.empty();
  var node_default = $('<option />', {'id':'line' + kbn + '_0','value':'0','selected':'selected'});
  node_parent.append(node_default);
  for(var cd in params['list']){
    var value = cd
    var id = 'line' + kbn + '_' + cd;
    var content = params['list'][cd];
    var node = $('<option />', {'id':id,'value':value}).text(content);
    node_parent.append(node);
  }

  var node_parent_station_from = $('#stationFrom' + kbn);
  var node_parent_station_to = $('#stationTo' + kbn);
  node_parent_station_from.empty();
  node_parent_station_to.empty();
  var node_default_station_from = $('<option />', {'id':'stationFrom' + kbn + '_0','value':'0','selected':'selected'});
  var node_default_station_to = $('<option />', {'id':'stationTo' + kbn + '_0','value':'0','selected':'selected'});
  node_parent_station_from.append(node_default_station_from);
  node_parent_station_to.append(node_default_station_to);

};

/**
 * 沿線の設定
 *
 */
(function () {
  $("#line1, #line2, #line3").on('change', function(el) {

    var kbn = '';
    switch ($(this).attr('id')){
      case 'line1':
        kbn = '1'
        break;
      case 'line2':
        kbn = '2'
        break;
      case 'line3':
        kbn = '3'
        break;
    }

    if ($(this).valid() && kbn != '') {
      var data = {line:$("option:selected", this).val()};
      oh_set_line(LINE_API_URL, kbn, data);
    }

  });
}());

/**
 * 沿線を設定する
 * @param {*} url
 * @param {*} kbn
 * @param {*} data
 */
var oh_set_line = function(url, kbn, data)
{
  $.ajax({
    mode: "abort",
    type: "get",
    url: url,
    data: data,
    dataType: 'json',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    success: function(params, status){oh_set_line_callback(params,kbn)}
  });
};

/**
 * 駅情報を取得し、内容を変更する関数(コールバック)
 * @param {*} params
 * @param {*} kbn
 */
var oh_set_line_callback = function(params,kbn)
{
  var node_parent_from = $('#stationFrom' + kbn);
  var node_parent_to = $('#stationTo' + kbn);
  node_parent_from.empty();
  node_parent_to.empty();
  var node_default_from = $('<option />', {'id':'stationFrom' + kbn + '_0','value':'0','selected':'selected'});
  var node_default_to = $('<option />', {'id':'stationTo' + kbn + '_0','value':'0','selected':'selected'});
  node_parent_from.append(node_default_from);
  node_parent_to.append(node_default_to);
  var over_100_cd_list = {};
  for(var cd in params['list']){
    if (cd < 100) {
      var id_from = 'stationFrom' + kbn + '_' + cd;
      var id_to = 'stationTo' + kbn + '_' + cd;
      var value = params['list'][cd]['station_cd'];
      var content = params['list'][cd]['station_snm'];
      var node_from = $('<option />', {'id':id_from,'value':value}).text(content);
      var node_to = $('<option />', {'id':id_to,'value':value}).text(content);
      node_parent_from.append(node_from);
      node_parent_to.append(node_to);
    } else {
      over_100_cd_list[cd] = params['list'][cd];
    }
  }
  for(var cd in over_100_cd_list) {
    var id_from = 'stationFrom' + kbn + '_' + cd;
    var id_to = 'stationTo' + kbn + '_' + cd;
    var value = params['list'][cd]['station_cd'];
    var content = params['list'][cd]['station_snm'];
    var node_from = $('<option />', {'id':id_from,'value':value}).text(content);
    var node_to = $('<option />', {'id':id_to,'value':value}).text(content);
    node_parent_from.append(node_from);
    node_parent_to.append(node_to);
  }
};

/**
 * もっと設定する押下
 *
 */
(function () {
  $("#more1").on('click', function(el) { oh_open_railway_input(1);});
  $("#more2").on('click', function(el) { oh_open_railway_input(2);});
}());

/**
 * もっと設定する押下
 * @param {*} rlNo
 */
var oh_open_railway_input = function(rlNo) {
	nrlNo = rlNo + 1;
	$('#more' + rlNo).hide();
	$('#more' + nrlNo).show();
	$('#railwayBlock' + nrlNo).show();
};

/**
 * 『さらに詳しく設定する』制御
 */
var oh_railway_more = function() {
  RWCompany2 = $('#railway2').val();
  RWCompany3 = $('#railway3').val();
  if ((RWCompany2 != undefined && RWCompany2 != 0) || (RWCompany3 != undefined && RWCompany3 != 0)) {
    if (RWCompany3 != undefined && RWCompany3 != 0) {
      $('#more1').hide();
      $('#more2').hide();
      $('#railwayBlock2').show();
      $('#railwayBlock3').show();
    } else {
      $('#more1').hide();
      $('#more2').show();
      $('#railwayBlock2').show();
      $('#railwayBlock3').hide();
    }
  } else {
    $('#more1').show();
    $('#more2').hide();
    $('#railwayBlock2').hide();
    $('#railwayBlock3').hide();
  }
};

/**
 * 市区町村選択情報 初期化
 *
 */
(function () {
  $("#area").on('change', function(el) {
    oh_reset_selected_city();
    // if ($(this).valid() && kbn != '') {}

  });
}());

/**
 * バックアップ用のグローバル変数
 */
var oh_popup_area_backup = {};

/**
 * 市区町村選択時に市区町村選択情報を初期化する
 */
var oh_reset_selected_city = function() {
	oh_popup_area_backup = {};
	$('#selected_area').empty();
	$('#selectedCityText').empty();
};

/**
 * 市区町村選択情報 ポップアップ
 *
 */
(function () {
  $("#selectedCityLink").on('click', function(el) {
    // $(window).off('beforeunload');
    oh_show_popup_area(AREA_API_URL);
  });
}());

/**
 * 市区町村選択ポップアップ表示時に呼び出される関数
 * @param {*} url
 */
var oh_show_popup_area = function(url) {
	areaCd = $('#area option:selected').val();
	if (areaCd == '0' || areaCd == null || areaCd == '') {
		alert("エリアが選択されていません");
	} else {
	  oh_create_popup_area_backup();
	  oh_create_popup_area(url,areaCd);
	}
};

/**
 * 市区町村選択ポップアップ表示時にhidden情報を保存領域に設定
 */
var oh_create_popup_area_backup = function() {
	var city_list = $('#selected_area :hidden[id^=city_]');
	city_list.each(function() {
		var city_info = {};
		city_info['checked'] = 'checked';
		oh_popup_area_backup[$(this).val()] = city_info;
	});
};

/**
 * 市区町村選択ポップアップのエリア情報を取得し、内容を変更する関数
 * @param {*} url
 * @param {*} areaCd
 */
var oh_create_popup_area = function(url,areaCd)
{
	data = {areaCd:areaCd};
	$.ajax({
    mode: "abort",
		type: "get",
		url: url,
		data: data,
		dataType: 'json',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
		// error: function(xhr, status, exception){alert("error:" + status);},
		success: function(params, status){oh_create_popup_area_callback(params);}
	});
};

/**
 * 市区町村選択ポップアップのエリア情報を取得し、内容を変更する関数(コールバック)
 * @param {*} params
 */
var oh_create_popup_area_callback = function(params) {

	var node_parent = $('#popup_area_select_list');
	node_parent.empty();

	var target_array = oh_popup_area_backup;
	$('#popup_area_nm').text(params['areaNm']);

	for(var cd in params['list']){
		var id = 'popup_area_cd_' + cd;
		var checked = null;
		if (oh_popup_area_backup != undefined && oh_popup_area_backup[cd] != undefined && oh_popup_area_backup[cd]['checked'] != undefined) {
			checked = oh_popup_area_backup[cd]['checked'];
		}
    var node_span = $('<span />');
    node_span.append($('<input />', {'type':'checkbox', 'id':id, 'value':cd, 'checked':checked}));
    node_span.append( $('<label/>', {'for':id}).text(params['list'][cd]));
		node_parent.append(node_span);
	}

	$('#popup_select_area').modal({clickClose:false});
};

/**
 * 市区町村選択ポップアップにて選択された市区町村情報を保存
 */
var oh_save_popup_area = function() {
	var temp_array = {};
	var area_cd = $('#popup_area_cd').val();
	var city_list = $('#popup_area_select_list :checkbox:checked');
	city_list.each(function() {
		var city_info = {};
		city_info['checked'] = 'checked';
		temp_array[$(this).val()] = city_info;
	});
	oh_popup_area_backup = temp_array;
};


/**
 * 市区町村選択情報 ポップアップ
 *
 */
(function () {
  $("#popup_submit").on('click', function(el) {
    // $(window).off('beforeunload');
    oh_set_popup_area(AREA_TEXT_API_URL);
  });
}());

/**
 * 市区町村選択ポップアップにて設定する
 * @param {*} url
 */
var oh_set_popup_area = function(url) {

	oh_save_popup_area();
	oh_set_popup_parameter_area();
	oh_set_popup_area_txt(url);
	oh_hide_popup_area();
};

/**
 * 市区町村選択ポップアップにて選択された市区町村情報を保存
 */
var oh_save_popup_area = function() {
	var temp_array = {};
	var area_cd = $('#popup_area_cd').val();
	var city_list = $('#popup_area_select_list :checkbox:checked');
	city_list.each(function() {
		var city_info = {};
		city_info['checked'] = 'checked';
		temp_array[$(this).val()] = city_info;
	});
	oh_popup_area_backup = temp_array;
};

/**
 * 市区町村選択ポップアップを閉じる
 */
var oh_hide_popup_area = function() {

	$('div').removeClass('blocker'); // モーダル解除
  $.modal.close();
	// $('#popup_select_area').hide();
};

/**
 * 選択された市区町村のテキストを設定する
 * @param {*} url
 */
var oh_set_popup_area_txt = function(url)
{
  var params = {};
  params["city_cd"] = oh_popup_area_backup;

  $.ajax({
    mode: "abort",
    type: "get",
    url: url,
    data: params,
    dataType: 'json',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    // error: function(xhr, status, exception){alert("error:" + status);},
    success: function(params, status){oh_set_popup_area_txt_callback(params);}
  });
};

/**
 * 市区町村選択ポップアップの市区町村情報を取得し、内容を変更する関数(コールバック)
 * @param {*} params
 */
var oh_set_popup_area_txt_callback = function(params) {

  var node_parent = $('#selectedCityText');
  node_parent.empty();
  // var node_ul = $('<ul />') , i = 0;
  var i = 0;

  // 要素数
  var last_cd = -1;
  for(city_cd in params) {
    last_cd++;
  }

  for (city_cd in params) {
    if (i != last_cd) {
      var node_span = $('<span />').html(params[city_cd] + '&nbsp;/&nbsp;');
      node_parent.append(node_span);
      i++;
    } else {
      var node_span = $('<span />').html(params[city_cd]);
      node_parent.append(node_span);
      i++;
    }
  }
  // node_parent.append(node_ul);
};

/**
 * 市区町村選択ポップアップでの選択情報を親画面に設定する
 */
var oh_set_popup_parameter_area = function() {

  var node = $('#selected_area').empty();

  for (city_cd in oh_popup_area_backup) {
    var id = 'city_' + city_cd;
    var name = 'city_cd[]';
    var value = city_cd;
    var node_hidden = $('<input />', {'type':'hidden', 'id':id, 'name':name, 'value':value});
    node.append(node_hidden);
  }
};

/**
 * 希望地域の制御
 *
 */
(function () {
  $("[name='cond_area_setting_kbn']").on('change', function() {
    oh_kibou_chiiki();
  });
}());

/**
 * 希望地域の制御
 *
 */
var oh_kibou_chiiki = function() {
  var val = $("[name='cond_area_setting_kbn']:checked").val();
  if (val == "1") {
    $("#group_area").show();
    $("#group_railway").hide();
  } else if (val == "2") {
    $("#group_area").hide();
    $("#group_railway").show();
  } else {
    $("#group_area").hide();
    $("#group_railway").hide();
  }
};

// /**
//  * 連絡方法選択時の制御
//  *
//  */
// (function () {
//   $("[id^=contact_way]").on('change',function() {
// 		oh_click_contact_way();
// 	});
// }());
// var oh_click_contact_way = function() {
//   oh_click_contact_way_toggle_class($('#customer_address1').closest('.c-form-item__input-row').siblings('.c-form-item__label'));
//   oh_click_contact_way_toggle_class($('#customer_address2').closest('.c-form-item__input-row').siblings('.c-form-item__label'));
// };
// var oh_click_contact_way_toggle_class = function ( el ) {
//   // 初期化
//   el.removeClass('--optional');
//   el.removeClass('--required');
//   // クラス付与
//   if ($('#contact_way4').prop('checked')) {
//     el.addClass('--required');
//   } else {
//     el.addClass('--optional');
//   }
// };

/**
 * ふりがな自動入力
 */
 $(function() {
  $.fn.autoKana('#name', '#nameKana');
});
